import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { ProgressCaption, VerticalProgressCaption } from "./Typography";
const useStyles = makeStyles(({ spacing, palette: { text }, additionalColors: { blue100, blue900 } }) => createStyles({
    root: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        margin: 4,
    },
    base: {
        gridColumnStart: 1,
        gridRowStart: 1,
        color: blue100,
    },
    progress: {
        gridColumnStart: 1,
        gridRowStart: 1,
    },
    overflow: {
        gridColumnStart: 1,
        gridRowStart: 1,
        color: blue900,
    },
    front: {
        zIndex: 1,
    },
    captionDiv: {
        gridColumnStart: 1,
        gridRowStart: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: text.primary,
    },
    labelDiv: {
        textAlign: "center",
    },
}));
export const LabeledProgressDial = ({ label, current, target, unit, variant = "lg", hideNumbers = false, labelText = "", }) => {
    const classes = useStyles();
    const circularProgressProps = {
        lg: {
            thickness: 5,
            size: 90,
        },
        md: {
            thickness: 4,
            size: 60,
        },
        sm: {
            thickness: 4,
            size: 45,
        },
        xs: {
            thickness: 3,
            size: 40,
        },
    };
    const value = (100 * current) / target;
    const formattedValue = Math.round(value);
    const valueText = variant === "sm" || variant === "xs" || hideNumbers ? formattedValue.toString() : `${formattedValue}%, ${current}${unit} / ${target}${unit}`;
    return (_jsxs("div", { children: [_jsxs("div", { className: classes.root, children: [_jsx(CircularProgress, { className: classes.base, variant: "determinate", color: "inherit", value: 100, ...circularProgressProps[variant] }), _jsx(CircularProgress, { className: classes.progress, variant: "determinate", value: Math.min(value, 100), "aria-label": labelText, "aria-valuetext": valueText, ...circularProgressProps[variant] }), value > 100 && (_jsx(CircularProgress, { className: classes.overflow, variant: "determinate", value: Math.min(value - 100, 100), "aria-label": labelText, "aria-valuetext": valueText, ...circularProgressProps[variant] })), _jsx("div", { className: classes.captionDiv, style: { width: circularProgressProps[variant].size }, "aria-hidden": "true", children: variant === "sm" || variant === "xs" || hideNumbers ? (_jsx(ProgressCaption, { current: current, target: target, unit: unit, excludeTarget: variant === "sm" || variant === "xs", hideNumbers: hideNumbers })) : (_jsx(VerticalProgressCaption, { current: current, target: target, unit: unit, width: variant === "lg" ? "35%" : "50%" })) })] }), _jsx("div", { className: classes.labelDiv, "aria-hidden": "true", children: label })] }));
};
export const NAProgressDial = () => {
    const classes = useStyles();
    return (_jsx("div", { children: _jsxs("div", { className: classes.root, children: [_jsx(CircularProgress, { className: classes.base, variant: "determinate", color: "inherit", value: 100, thickness: 3, size: 40 }), _jsx(CircularProgress, { className: classes.progress, variant: "determinate", value: 100, thickness: 3, size: 40 }), _jsx("div", { className: classes.captionDiv, "aria-hidden": "true", children: _jsx(Typography, { variant: "subtitle1", children: "N/A" }) })] }) }));
};
//# sourceMappingURL=LabeledProgressDial.js.map